export default __webpack_public_path__ + "static/media/Palabra muy bien.55780bf5.png";